import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import {
  Card,
  Button,
  Col,
  Row,
  Dropdown,
  Image,
  Container,
  Tabs,
  Tab,
  Form
} from "react-bootstrap";
import TableForm from "../../../../components/TableForm";
import ConfirmModal from "../../../../components/ConfirmModal";
import Teams from "./team";
import WorkCalendar from "../../HeadPlanning/Tabs/calendar";
import {
  getServiceRequest,
  addEditServiceRequest
} from "../../../../commons/ServiceRequest";
import TechniciansService from "../../../../services/technician.service";
import TechnicianPlansService from "../../../../services/technicianreceive.service";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import DepartJobsService from "../../../../services/departjob.service";
import ReasonsService from "../../../../services/reasons.service";
import { formatInputDate } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";
import TableForm2s from "../../../../components/TableFormScrb";

const defaultDatas = [
  {
    Id: null,
    Seq_Inst_Id: 0,
    Job_Other_Id: 0,
    Seq_Pm_Id: 0,
    Seq_Serv_Id: null,
    Job_Type_Id: 0,
    Tech_Plan_Id: null, // Added Tech_Plan_Id with null value
    Seq_Oth_No: null,
    Tech_Rev_No: null,
    Tech_Doc_Date: null,
    Seq_Status_Id: null,
    Seq_St_Name: null,
    Depart_St_Id: null,
    Tech_Mas_ID: null,
    Tech_Mas_Name: null,
    Job_Type_Name: null,
    Cus_Code: null,
    Cus_Name: null,
    Job_Actual_Date: null,
    Reject_Reason: null, // Added Reject_Reason with null value
    Tech_Rev_Date: null,
    Tech_Reject: null,
    Com_Code: null
  }
];

export default function TeamDetailEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pData, setPdata] = useState([]);
  const [data, setData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("JobDetails");
  const [dataModal, setDataModal] = useState({ Array: [defaultDatas[0]] });
  const [validated, setValidated] = useState(false);
  const [seqStsMas, setSeqStsMas] = useState([]);
  const [deapStsMas, setDeapStsMas] = useState([]);
  const [deapStsMasF, setDeapStsMasF] = useState([]);
  const vTechReject = [
    {
      "Status": "Accept", "Sts": false
    }
    , {
      "Status": "Reject", "Sts": true
    }
  ];

  const columns = [
    {
      name: "Tech_Rev_Date",
      label: "วันรับงาน",
      format: (row) => formatDate(row?.Tech_Rev_Date),
      readOnly: true,
      width: "150px"
    },
    {
      name: "Tech_Rev_No",
      label: "เลขที่รับงาน",
      readOnly: true
    },
    {
      name: "Job_Type_Name",
      label: "ประเภทงาน",
      readOnly: true,
      width: "190px"
    },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      width: "200px"
    },
    { name: "Cus_Code", label: "รหัสลูกค้า/สาขา", readOnly: true, width: "190px" },
    { name: "Cus_Name", label: "ชื่อลูกค้า/สาขา", readOnly: true, width: "250px" },
    // { name: "Job_Cus_Date", label: "วันที่เข้างานจริง", readOnly: true, format: (row) => formatDate(row?.Job_Cus_Date), },
    { name: "Job_Actual_Date", label: "วันที่เข้างาน", width: "150px", readOnly: true, format: (row) => formatDate(row?.Job_Actual_Date), },
    {
      name: "Depart_St_Id",
      label: "สถานะงาน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Depart_St_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Depart_St_Name",
        dataset: deapStsMasF
      })
    },
    {
      name: "Seq_Status_Id",
      label: "สถานะใบสั่งงาน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Seq_St_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Seq_St_Name",
        dataset: seqStsMas
      })
    },
    // {
    //   name: "Tech_Reject",
    //   label: "สถานะรับงาน",
    //   type: "select",
    //   disabled: true,
    //   required: true,
    //   noneAsync: true,
    //   filterBy: ["Tech_Reject"],
    //   options: initializeSetOption({
    //     key: "Sts",
    //     label: "Status",
    //     dataset: vTechReject
    //   })
    // }
  ];

  useEffect(() => {
    handleChangeTab("JobDetails");
    if (state === "JobDetails" || state == null) {
      setTimeout(() => setWebsiteName("ข้อมูลการรับงาน"), 300);
    }
    GetAllTP();

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => setSeqStsMas(res)
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DepartJobsService.getAllDepartJobs(),
      callback: (res) => setDeapStsMas(res)
    });
  }, []);

  useEffect(() => {
    // const desiredIds = [4, 5];
    // const newArray = deapStsMas.filter(item => desiredIds.includes(item.Id));
    // setDeapStsMasF(newArray);
    setDeapStsMasF(deapStsMas);
  }, [deapStsMas]);

  useEffect(() => {
    pSetData(pData);
  }, [pData]);

  const GetAllTP = () => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.getTechnicianReceive(id),
      callback: (res) => setPdata(res.data)
    });
  };

  const pSetData = (vData) => {
    let a = { data: [vData] };
    const newArray = a.data.map((items) => ({
      Id: items.Id,
      Seq_Inst_Id: items?.Seq_Inst_Id,
      Job_Other_Id: items?.TechnicianPlan?.SeqOthersJob?.Job_Other_Id,
      Seq_Pm_Id: items?.Seq_Pm_Id,
      Seq_Serv_Id: items.Seq_Serv_Id,
      Job_Type_Id: items?.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Job_Type_Id ||
        items.TechnicianPlan?.SeqInstalljob?.job_type_id,
      Tech_Plan_Id: items.TechnicianPlan?.id,
      Seq_No: items.TechnicianPlan?.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlan?.SeqInstalljob?.seq_install_no ||
        items.TechnicianPlan?.RepairJobs?.seq_repair_no||
        items.TechnicianPlan?.SeqPmJob?.Seq_Pm_No,
      Tech_Rev_No: items.tech_rev_no,
      Tech_Doc_Date: formatInputDate(items.Tech_Doc_Date, "Local").date,
      Seq_Status_Id: items.SequneceStatus?.Id,
      Seq_St_Name: items.SequneceStatus?.Seq_St_Name,
      Depart_St_Id: items.depart_st_id,
      Tech_Mas_Id: items.TechnicianPlan?.tech_mas_id,
      Tech_Mas_Name: items.Technician?.tech_mas_name,
      Job_Type_Name: items.JobType?.Job_Type_Name,
      // items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.JobType?.Job_Type_Name,
      Cus_Code: items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
        items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code ||
        items.TechnicianPlan?.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Code,
      Cus_Name: items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
        items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name ||
        items.TechnicianPlan?.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Code,
      Job_Actual_Date: formatInputDate(items.TechnicianPlan?.job_actual_date, "Local").date,
      Reject_Reason: items.Reject_Reason,
      Tech_Rev_Date: formatInputDate(items.tech_rev_date, "Local").date, //new Date().toISOString().substring(0, 10),
      Tech_Reject: items.tech_reject,
      Com_Code: items.com_code,
      Job_Cus_Date: formatInputDate(items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Job_Cus_Date, "Local").date
    }));
    setData(newArray);
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        acceptance: "ทีมงานรับงาน",
        JobDetails: "ข้อมูลการรับงาน",
        CheckEquipment: "ตรวจรับอุปกรณ์/อะไหล่",
        CheckJobDetails: "ตรวจสอบรายละเอียดงาน",
        EventplaningCalendar: "ปฏิทินงานช่าง",
      }
    });
  };

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback) {
      try {
        await handleSubmitTechReceive(dataCallback);
      } catch (error) {
        // Handle errors from handleSubmitPlanDts
        console.error(error);
      }
    }
  };

  const handleSubmitTechReceive = async (Plan) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.editTechnicianReceive(
        id,
        Plan[0]
      ),
      navigated: (navi) =>
        navi &&
        navigate("/service_work/acceptance", {
          state: { name: "JobDetails" }
        })
    });
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "JobDetails"}
          onSelect={(k) => handleChangeTab(k)}
          className="mb-3"
        >
          <Tab eventKey="acceptance" title="ทีมงานรับงาน" disabled>
            {websiteName === "ทีมงานรับงาน" && <Teams />}
          </Tab>
          <Tab eventKey="JobDetails" title="ข้อมูลการรับงาน">
            <Form noValidate validated={validated} onSubmit={handleValidated}>
              <Card className="m-1 mb-4 p-4 border-0">
                <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
                  <Card.Title className="mb-0 fs-2 text-dark">
                    รายละเอียดการแก้ไข
                  </Card.Title>
                </Card.Header>

                <Card.Body style={{ overflowX: "auto" }}>
                  <TableForm2s
                    data={data}
                    defaultData={defaultDatas[0]}
                    columns={columns}
                    isLoading={loading}
                    editForm={true}
                    pagination={false}
                    onChangeCallback={(newData) => {
                      const aForSave = newData.map((item) => ({
                        tech_plan_id: Number(item.Tech_Plan_Id),
                        seq_status_id: Number(item.Seq_Status_Id),
                        depart_st_id: Number(item.Depart_St_Id),

                        // tech_mas_id: Number(item.Tech_Mas_Id),
                        // job_type_id: Number(item.Job_Type_Id),
                        // tech_rev_no: item.Tech_Rev_No,
                        // tech_rev_date: item.Tech_Rev_Date,
                        // tech_reject: Boolean(item.Tech_Reject),
                        // com_code: item.Com_Code
                      }));
                      setData(newData);
                      setDataModal({ Array: aForSave });
                    }}
                  />
                </Card.Body>

                <Row className="justify-content-end mt-3">
                  <Col className="col-auto">
                    <Button
                      type="submit"
                      variant="success"
                      className="me-2 px-5 py-2 text-dark rounded-pill"
                      onClick={() => setShowModal(!showModal)}
                    >
                      บันทึกข้อมูล
                    </Button>
                    <ConfirmModal
                      show={showModal}
                      data={dataModal.Array}
                      content={"save"}
                      onSubmitCallback={handleSubmit}
                    />
                    <Button
                      variant="outline-secondary"
                      className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                      onClick={() =>
                        navigate("/service_work/acceptance", {
                          state: { name: "JobDetails" }
                        })
                      }
                    >
                      ย้อนกลับ
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Form>
          </Tab>
          <Tab
            eventKey="CheckEquipment"
            title="ตรวจรับอุปกรณ์/อะไหล่"
            disabled
          ></Tab>
          <Tab
            eventKey="CheckJobDetails"
            title="ตรวจสอบรายละเอียดงาน"
            disabled
          ></Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง" disabled>
            {websiteName === "ปฏิทินงานช่าง" && <WorkCalendar />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
